var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"case_type",class:_vm.caseType == 'Чиновники' ? 'clerk' : 'business',attrs:{"height":"40"}},[_c('text',{attrs:{"x":"0","y":"39"}},[_vm._v(_vm._s(_vm.caseType))])])}
var staticRenderFns = []

export { render, staticRenderFns }